// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"6844cb78","455":"44dfd35e","977":"5ac0b900"}[chunkId] + ".chunk.js";
};